import { SettingsBox } from 'src/Elements/Data'
import { Select, TextField } from 'src/Libs/inputs/react-hook-form'
import { EmsProductType } from 'src/Routes/Installation/InstallationModel'
import React from 'react'
import { Stack } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const NewInstallationForm: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Stack gap={1}>
      <SettingsBox
        title={'create-new-installation.form.name'}
        suffix={<TextField name={'partnersInstallationName'} label={t('common.name')} fullWidth />}
      />
      <SettingsBox
        title={'create-new-installation.form.storage-type'}
        suffix={
          <Select
            fullWidth
            name={'storageType'}
            options={[{ value: EmsProductType.qntm, label: t(`create-new-installation.form.product-type.qntm`) }]}
            disabled
          />
        }
      />
    </Stack>
  )
}

export default NewInstallationForm
